import { IService } from "./WhyUsSection";

export const IconBox = ({ header, description, icon }: IService) => (
  <div className="col-xl-4" data-aos="fade-up" data-aos-delay="200">
    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
      <i className={`bi ${icon}`}></i>
      <h4>{header}</h4>
      <p>{description}</p>
    </div>
  </div>
);
